import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  headers: any = {
    'Content-Type': 'application/json'
  };

  constructor(
    private http: HttpClient,
    private gfService: GlobalFunctionService,
    private appInit: AppInitializerService
  ) { }

  getRequests(params: any, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    headers = this.gfService.JSONMerge(headers, this.headers);
    const options = {
      headers: new HttpHeaders(headers),
      params
    };
    const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `course/enrolmentrequestlist`;
    return this.http.get(api, options);
  }

  moderate(params: any = {}, resourceID: number, status: number, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    headers = this.gfService.JSONMerge(headers, this.headers);
    const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `internalevent/${resourceID}/moderate/${status}`;
    const options = {
      headers: new HttpHeaders(headers)
    };
    return this.http.put(api, params, options);
  }


  saveInternalEvent(params: any, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    headers = this.gfService.JSONMerge(headers, this.headers);
    delete headers['Content-Type'];
    const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `internalevent`;
    const options = {
      headers: new HttpHeaders(headers)
    };
    return this.http.post(api, params, options);
  }

  updateInternalEvent(params: any, id: number, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    headers = this.gfService.JSONMerge(headers, this.headers);
    delete headers['Content-Type'];
    const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `internalevent/${id}`;
    const options = {
      headers: new HttpHeaders(headers)
    };
    return this.http.put(api, params, options);
  }
}
